export default "__VITE_ASSET__DMDCJCfC__"